import React from "react";
import { array, string, bool } from "prop-types";

import NewsWithImage from "../../../molecules/NewsWithImage";

import "./organism1.m.css";

const Organism1 = ({ storyList, className = "", isMobile }) => {
  if (!(storyList && storyList.length)) {
    return null;
  }

  return (
    <div styleName="base" className={className}>
      {
        <div styleName="lead-storycard">
          <NewsWithImage
            story={storyList[0].story}
            aspectRatio={[(16, 9)]}
            imageType="image16x9"
            cssStyleName="semiBigSize"
            showExcerpt={false}
          />
        </div>
      }
      {storyList.slice(1, storyList.length).map(({ story }, index) => (
        <div key={index} styleName={`story-${index + 1}`}>
          <NewsWithImage story={story} key={index} showExcerpt={(!isMobile && index === 0) || false} />
        </div>
      ))}
    </div>
  );
};

Organism1.propTypes = {
  storyList: array.isRequired,
  className: string,
  isMobile: bool,
};

export default Organism1;
